import React from 'react';
import NumberFormat from 'react-number-format';

interface Props {
    value: string | number,
    className?: string
}

const DefaultAmountFormatter: React.FC<Props> = ({ value, className }) => (
    <NumberFormat
        value={typeof value === 'string' ? parseFloat(value) : value}
        className={className}
        displayType="text"
        decimalSeparator=","
        thousandSeparator="."
        prefix="$"
        decimalScale={2}
        fixedDecimalScale
        isNumericString
    />
);

export default DefaultAmountFormatter;
